import { FormProvider } from "react-hook-form";
import { nameof } from "ts-simple-nameof";
import styles from "./PasswordSection.module.scss";
import { usePasswordForm } from "../hooks/usePasswordForm";
import { IMyPasswordFormModel } from "../models/myPasswordFormModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";

export const PasswordSection = () => {
  const { form, onSubmit, isSaving } = usePasswordForm();

  return (
    <section className={styles.section}>
      <FormProvider {...form}>
        <form onSubmit={onSubmit} className={styles.form} noValidate>
          <DefaultInputField
            name={nameof<IMyPasswordFormModel>((x) => x.currentPassword)}
            label="Текуща парола"
            placeholder="••••••"
            type="password"
            required
            autocomplete="current-password"
            width="100%"
          />
          <DefaultInputField
            name={nameof<IMyPasswordFormModel>((x) => x.newPassword)}
            label="Нова парола"
            placeholder="••••••"
            type="password"
            required
            autocomplete="new-password"
            width="100%"
          />
          <DefaultInputField
            name={nameof<IMyPasswordFormModel>((x) => x.confirmNewPassword)}
            label="Потвърди нова парола"
            placeholder="••••••"
            type="password"
            required
            autocomplete="new-password"
            width="100%"
          />
          <div className={styles.formActions}>
            <DefaultButton
              label="Смяна на паролата"
              type="submit"
              design="accent"
              loading={isSaving}
            />
          </div>
        </form>
      </FormProvider>
    </section>
  );
};
